import React, { useState, useEffect } from "react";
import image from "../../../../Resources/images/japan.jpg";
import { MdDelete, MdClose, MdEdit } from "react-icons/md";
import Table from "../../../UI/Table/Table";
import MasterDeleteModal from "../../../UI/Model/MasterDeleteModel/MasterDeleteModel";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";

function ViewStaff({ searchText, getStaff, Tbody }) {
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const [ID, setID] = useState("");
  const [storeID, setStoreID] = useState(false);
  const [storeImage, setStoreImage] = useState("");
  const [showModel, setShowModel] = useState(false);
  const Schema = yup.object().shape({
    staff_name: yup.string().required("Staff name name is required"),
    // image: yup.string().required("Image is required"),
    // allData: yup.string().required("Email is required"),
  });
  const handleChange = (e) => {
    // alert("working");
    if (e.target.files.length !== 0) {
      setStoreImage(e.target.files[0]);
    }
    // console.log(e.target.files[0]);
  };
  const StaffFormData = [
    {
      label: "staff Name",
      type: "text",
      apikey: "staff_name",
      placeholder: "Staff name ",
    },
    {
      label: "address",
      type: "text",
      apikey: "address",
      placeholder: "Address ",
    },
    {
      label: "contact no",
      type: "number",
      apikey: "phone_no",
      placeholder: "Contact no ",
    },
    {
      label: "email",
      type: "email",
      apikey: "email",
      placeholder: "Email  ",
    },
    {
      label: "salary",
      type: "number",
      apikey: "salary",
      placeholder: "Salary  ",
    },
    {
      label: "role",
      type: "select",
      apikey: "role",
      options: [
        { value: "user", id: 0 },
        { value: "reception", id: 1 },
      ],
      // placeholder: "role  ",
    },
  ];
  const tHead = [
    { title: "s.nO", width: "10%" },
    { title: "staff Name", width: "20%" },
    { title: "staff Image", width: "20%" },
    { title: "address", width: "10%" },
    { title: "contact Number", width: "10%" },
    { title: " salary", width: "10%" },
    { title: "email", width: "10%" },
    { title: "action", width: "30%" },
  ];

  const DeleteItems = () => {
    // console.log(idStore);
    axios
      .delete(`/staff/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          setMessage(false);
          getStaff(idStore);
          toast.error("Staff data has been deleted sucessfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
  };

  useEffect(() => {
    getStaff();
  }, []);
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const Edit = (values) => {
    setID(values);
    // setStoreImage(values?.image);
    // setStoreImage([...values.image]);

    setShowModel(true);
    // console.log(values);
    // setStoreImage([...values.image]);
  };
  useEffect(() => {
    setStoreID(ID);
  }, [ID, storeID]);
  const Submits = (value) => {
    // value.details = storeDescription;
    value.image = storeImage;
    console.log(value);
    let formData = new FormData();
    formData.append("Brand_name", value.Brand_name);
    formData.append("image", value.image);
    // storeImage.map((val, i) => {
    //   return formData.append("image", val);
    // });
    // value.name = ID.name;
    // value.tId = ID.tId;
    // value.createdAt = ID.createdAt;
    // console.log(value);
    axios
      .patch(`/brand/${ID.id}`, formData)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setShowModel(false);
          // setStoreDescription("");
          toast.info("Brand has been updated sucessfuly");
          getStaff();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  let mod;
  mod = (
    <div
      className={`${
        showModel ? " absolute  z-50 top-0 bottom-0 right-0 left-0" : ""
      }`}
    >
      <div
        className={` ${
          showModel ? "translate-y-0 " : "-translate-y-full "
        }  duration-700 delay-300 ease-in-out fixed top-0 bottom-0 right-0 left-0  z-40 `}
      >
        <div
          className=" relative z-50 bg-[white] rounded-md top-[12%]  flex 
         p-5 w-[70%] mx-auto h-fit "
        >
          <div className="w-[95%] my-4">
            {/* {console.log(ID)} */}
            <Formik
              initialValues={{
                staff_name: ID?.staff_name ? ID?.staff_name : "",
                phone_no: ID?.phone_no ? ID?.phone_no : "",
                address: ID?.address ? ID?.address : "",
                email: ID?.email ? ID?.email : "",
                salary: ID?.salary ? ID?.salary : "",
                role: ID?.role ? ID?.role : "",
                // image: ID?.image ? ID?.image : "",
              }}
              validationSchema={Schema}
              onSubmit={(values, { resetForm }) => {
                console.log(values);
                Submits(values);
                resetForm();
              }}
            >
              {({ values, errors, touched, handleSumit, isSubmitting }) => (
                <Form>
                  <div className={`   gap-6`}>
                    {StaffFormData?.map((val, i) => {
                      if (val.type === "file") {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>

                            {/* <div className="grid grid-cols-12  space-x-1 gap-3 border p-1 h-64 "> */}
                            <label htmlFor="image">
                              <div className=" w-full">
                                <div className="w-full h-full  relative  p-1.5 overflow-hidden">
                                  <img
                                    src={
                                      storeImage
                                        ? URL.createObjectURL(storeImage)
                                        : `${process.env.REACT_APP_API_URL}/public/${ID?.image}`
                                    }
                                    alt="Loading..."
                                    className="object-cover mx-5 w-full h-96 object-top"
                                  />
                                </div>
                              </div>
                            </label>
                            {/* </div> */}
                            <input
                              id="image"
                              type={"file"}
                              accept={val.accept}
                              name={val.apikey}
                              onChange={(e) => handleChange(e)}
                              className="bg-white hidden relative z-50  outline-none rounded-sm 
                                    border-none px-2 py-1"
                            />
                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>
                            <div className="relative">
                              <Field
                                id={val.apikey}
                                placeholder={val.placeholder}
                                name={val.apikey}
                                className="border border-gray-300 px-3 py-2.5  w-11/12 laptop:w-full rounded-md"
                              />
                            </div>

                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  <div className="flex justify-start  mt-5 w-11/12">
                    <button
                      type="submit"
                      className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
                    >
                      submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div
            className="absolute top-5 border border-gray-600  text-gray-600 bg-white  
            hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer right-10"
            onClick={() => {
              setShowModel(false);
              setID(null);
              setStoreImage("");
            }}
          >
            <MdClose />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  return (
    <div className=" p-6">
      <div
        className={`${
          showModel
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showModel ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showModel ? mod : ""}
        </div>
      </div>
      <ToastContainer />
      <Table celspacing={0} cellPadding={0} Head={tHead}>
        {Tbody?.map((val, i) => {
          return (
            <tr key={i} className=" w-full font-medium text-gray-700">
              <td className="border-b p-2 text-center"> {i + 1}</td>
              <td className="border-b p-2 text-center capitalize  ">
                {val.staff_name}
              </td>
              <td className="border-b p-2 ">
                <div className="flex justify-center ">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public/${val?.employee_img}`}
                    alt="loading ..."
                    height="50px"
                    width="50px"
                    className="rounded-full w-16 h-16"
                  />
                </div>
              </td>
              <td className="border-b p-2 text-center capitalize">
                {val.address}
              </td>
              <td className="border-b p-2 text-center capitalize">
                {val.phone_no}
              </td>
              <td className="border-b p-2 text-center ">Rs. {val.salary}</td>
              <td className="border-b p-2 ">
                <div className="  ml-10 ">{val.email} </div>
              </td>
              <td className="border-b p-2 text-center border-r">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}

export default ViewStaff;
